import React from 'react'

// One icon per caseTypeArray/caseTypeClientOptions id, matching the case
// creation design's category picker exactly (design artboard "Case
// details"). Kept as a single lookup component so RecursiveContainer's
// generic select-card renderer can stay generic and just ask for "the icon
// for this id" without knowing about case categories itself.
const PATHS = {
  accident: <><path d="M5 17h14M6 17l1.5-6h9L18 17M9 11V6h6v5" /><circle cx="7.5" cy="19" r="1.5" /><circle cx="16.5" cy="19" r="1.5" /></>,
  death: <><rect x="10" y="9" width="4" height="10" rx="1" /><path d="M12 3c1 2 2 3 2 4a2 2 0 1 1-4 0c0-1 1-2 2-4z" /></>,
  injury: <path d="M3 12h4l2-7 4 14 2-7h6" />,
  malpractice: <><rect x="4" y="4" width="16" height="16" rx="4" /><path d="M12 8v8M8 12h8" /></>,
  assualt: <path d="M12 2l8 4v6c0 5-3.5 8-8 10-4.5-2-8-5-8-10V6z" />,
  liability: <><path d="M21 8l-9-5-9 5 9 5 9-5z" /><path d="M3 8v8l9 5 9-5V8" /><path d="M12 13v8" /></>,
  employment: <><rect x="3" y="7" width="18" height="13" rx="2" /><path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" /><path d="M3 13h18" /></>,
  nonSexualAssault: <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.6l-1-1a5.5 5.5 0 1 0-7.8 7.8l1 1L12 21l7.8-7.8 1-1a5.5 5.5 0 0 0 0-7.6z" />,
  business: <><rect x="5" y="3" width="14" height="18" rx="1" /><path d="M8 8h8M8 12h8M8 16h5" /></>,
  birthInjuries: <><circle cx="12" cy="8" r="4" /><path d="M8 14c0 4 2 6 4 6s4-2 4-6" /></>,
};

export default function CaseCategoryIcon({ id, active }) {
  const path = PATHS[id];
  if (!path) return null;
  return (
    <svg
      width="18" height="18" viewBox="0 0 24 24" fill="none"
      stroke={active ? "#8a6231" : "rgba(20,33,61,.5)"}
      strokeWidth="1.7"
      className="flex-none"
    >
      {path}
    </svg>
  );
}
